import { BrowserModule } from '@angular/platform-browser';
import { NgModule, forwardRef, ErrorHandler } from '@angular/core';

import { AppComponent } from './app.component';
import { Routes, RouterModule } from '@angular/router';
import { SocketService } from 'projects/game-utils/src/lib/service/socket.service';
import { WarcabyGameService } from './services/warcaby-game.service';
import { ImageService } from './services/image.service';
import { AbstractImageService } from 'projects/game-utils/src/lib/service/abstract.image.service';
import { EventsSourceRunner } from 'projects/game-utils/src/lib/event-source/service/EventsSourceRunner';
import { WarcabyEventSourceRunnerService } from './services/warcaby-event-source-runner.service';
import { AbstractGs } from 'projects/game-utils/src/lib/service/AbstractGs';
import { ErrorHandlerService } from './services/error-handler.service';
import { ChooseModeComponent } from './choose-mode/choose-mode.component';
import { GameVindowComponent } from './game-vindow/game-vindow.component';
import { HttpClientModule } from '@angular/common/http';
import { HeartComponent } from 'projects/game-utils/src/lib/game-window/dynamicpanel/heart/heart.component';
import { HeartImageComponent } from 'projects/game-utils/src/lib/game-window/dynamicpanel/heart-image/heart-image.component';
import { BarComponent } from 'projects/game-utils/src/lib/game-window/dynamicpanel/bar/bar.component';
import { BarGroupComponent } from 'projects/game-utils/src/lib/game-window/dynamicpanel/bar-group/bar-group.component';
import { BarBgComponent } from 'projects/game-utils/src/lib/game-window/dynamicpanel/bar-bg/bar-bg.component';
import { ProgresContainerComponent } from 'projects/game-utils/src/lib/game-window/dynamicpanel/progres-container/progres-container.component';
import { ProgressTimerComponent } from 'projects/game-utils/src/lib/game-window/dynamicpanel/progress-timer/progress-timer.component';
import { AlertWindowComponent } from 'projects/game-utils/src/lib/windows/alert-window/alert-window.component';

const appRoutes: Routes = [
  {path: '', redirectTo: 'chooseMode', pathMatch: 'full'},
  {path: 'server/verify/mahwarcabyjong', component: ChooseModeComponent },
  {path: 'chooseMode', component: ChooseModeComponent},
  {path: 'gameBoard', component: GameVindowComponent}
];

@NgModule({
  declarations: [
    AppComponent,
    ChooseModeComponent,
    GameVindowComponent,
    HeartComponent,
    HeartImageComponent,
    BarComponent,
    BarGroupComponent,
    BarBgComponent,
    ProgresContainerComponent,
    ProgressTimerComponent,
    AlertWindowComponent
  ],
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: true } // <-- debugging purposes only
    ),
    BrowserModule,
    HttpClientModule
  ],
  providers: [
    SocketService, 
    {provide: ErrorHandler, useClass: ErrorHandlerService},
    {
      provide: AbstractGs,
      useExisting: forwardRef( () => WarcabyGameService )
    },
    {
      provide: AbstractImageService,
      useExisting: forwardRef( () => ImageService )
    },
    {
      provide: EventsSourceRunner,
      useExisting: forwardRef( () => WarcabyEventSourceRunnerService )
    }
    
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
